export const WEB_APP_FULL_SCREEN_ROUTES = [
  "/admin/:communityId/events/drafts/:id",
  "/admin/:communityId/events/:id",
  "/settings/change-pin",
] as const;
